import FormRadio from "./components/radio";
import FormCheckbox from "./components/checkbox";
import FormJudge from "./components/judge";
import FormInput from "./components/input";
import FormTextarea from "./components/textarea";
import FormSelect from "./components/select";
import FormSelectMulti from "./components/select-multi";
import FormLocation from "./components/location";
import FormDate from "./components/date";
import FormDateTime from "./components/date-time";
import FormImgUpload from "./components/img-upload";
import FormVideoUpload from "./components/video-upload";
import FormFileUpload from "./components/file-upload";

// form组件类型
export const COMP_TYPE = {
  // 1\=单选；2\=多选；3\=判断；4\=文本框；5\=文本域；6\=下拉单选；7\=下拉多选；101\=定位打卡；102\=图片上传；103\=文件上传；104=日期；105=视频上传；106=日期+时间;
  RADIO: 1,
  CHECKBOX: 2,
  JUDGE: 3,
  INPUT: 4,
  TEXTAREA: 5,
  SELECT: 6,
  SELECT_MULTI: 7,
  LOCATION: 101,
  IMAGE_UPLOAD: 102,
  FILE_UPLOAD: 103,
  DATE: 104,
  VIDEO_UPLOAD: 105,
  DATETIME: 106,
};

export const COMP_TYPE_ITEM = {
  [COMP_TYPE.RADIO]: FormRadio,
  [COMP_TYPE.CHECKBOX]: FormCheckbox,
  [COMP_TYPE.JUDGE]: FormJudge,
  [COMP_TYPE.INPUT]: FormInput,
  [COMP_TYPE.TEXTAREA]: FormTextarea,
  [COMP_TYPE.SELECT]: FormSelect,
  [COMP_TYPE.SELECT_MULTI]: FormSelectMulti,
  [COMP_TYPE.LOCATION]: FormLocation,
  [COMP_TYPE.DATE]: FormDate,
  [COMP_TYPE.DATETIME]: FormDateTime,
  [COMP_TYPE.IMAGE_UPLOAD]: FormImgUpload,
  [COMP_TYPE.FILE_UPLOAD]: FormFileUpload,
  [COMP_TYPE.VIDEO_UPLOAD]: FormVideoUpload,
};

// input组件类型
// 类型限制：1\=字符串；2\=正整数；3\=浮点数；4\=英文；5\=数字
export const INPUT_TYPE = {
  TEXT: 1,
  POSITIVE_INTERGER: 2,
  FLOATING_NUMBER: 3,
  ENG: 4,
  NUMBER: 5,
};
